module.exports = __webpack_public_path__ + "img/brightness-alt-high.2c830601.svg";